import { ageInYears } from '@/lib/format';

/** Shape-only check for a v1-v5 UUID string — used to validate a manually-entered
 * `assignedEmployee` user id (Sales lead assign/create — there is no staff-user directory endpoint
 * to pick from yet, see `leads.api.ts`/`LeadFormPage.tsx`). Blocking client-side (the server would
 * 400 on anything else anyway). */
export const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Shape-only check mirroring `NATIONAL_ID_PATTERN` (`packages/shared/src/constants`) — 14 numeric
 * digits. This is enforced (blocking) server-side; here it's used only to drive the non-blocking
 * amber warning before submit, per 08-staff-ux.md §5.2 ("warn, don't block"). */
export function isPlausibleNationalId(value: string): boolean {
  return /^\d{14}$/.test(value);
}

/** Soft warning only — Egyptian mobile pattern `01[0,1,2,5]xxxxxxxx`. */
export function isPlausibleEgyptianPhone(value: string): boolean {
  return /^01[0125]\d{8}$/.test(value.replace(/[\s-]/g, ''));
}

/** Non-blocking amber note if the applicant's age falls outside the usual 3-25y band. */
export function isDateOfBirthInUsualRange(dateOfBirthIso: string): boolean {
  const age = ageInYears(dateOfBirthIso);
  if (age == null) return true;
  return age >= 3 && age <= 25;
}
